import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { SORTING } from '../../constants';

export const TableBody = ({
  columns,
  data,
  colFilter,
  to,
  compiler,
  popUp,
  setPopUp,
  setPopUpData,
  sortInfo = {},
  handleSort,
  func,
  tooltip,
  showCollapseTable,
  collapseTableDataFunction
}) => {
  const navigate = useNavigate();

  const [sortedData, setSortedData] = useState([]);
  const [expandedRowIndices, setExpandedRowIndices] = useState([]);
  const [collapseTableData, setCollapseTableData] = useState({});
  const [isCollapseTableOpen, setIsCollapseTableOpen] = useState({});


  const toggleRow = async (index, row) => {
    if (!showCollapseTable) return;

    const move_id = row.move_id;
    const isCurrentlyOpen = isCollapseTableOpen[move_id];

    setIsCollapseTableOpen(prev => ({
      ...prev,
      [move_id]: !isCurrentlyOpen,
    }));

    setExpandedRowIndices(prev =>
      isCurrentlyOpen ? prev.filter(i => i !== index) : [...prev, index]
    );
    if (!isCurrentlyOpen && collapseTableData[move_id] === undefined) {
      try {
        const response = await collapseTableDataFunction({ data: { move_id } });
        setCollapseTableData(prev => ({
          ...prev,
          [move_id]: response?.data ?? [],
        }));
      } catch (error) {
        console.error("Collapse data fetch failed for move_id:", move_id, error);
        setCollapseTableData(prev => ({
          ...prev,
          [move_id]: [],
        }));
      }
    }
  };


  const handleRowClick = ({ data, url }) => {
    if (to) {
      navigate(`${to}/${url}`, {
        state: { ...data, _listUrl: window.location.pathname + window.location.search },
      });
    }
  };

  const filteredColumns = colFilter
    ? columns
    : columns.filter((column) => column.name !== 'checkbox');

  // to sort data if sortInfo changes

  useEffect(() => {
    // if (Array.isArray(data)) {
    if (Array.isArray(data) || Object.keys(data).length > 0) {
      let finalData = compiler?.use ? compiler.tool(data) : data;
      if (sortInfo.sortType !== SORTING.DEFAULT) {
        let result = handleSort({ sortInfo, data: finalData });
        setSortedData(result);
      } else {
        setSortedData(finalData);
      }
    }
  }, [sortInfo, data]);
  return (
    <tbody>
      {sortedData.map((row, rowIndex) => (
        <>
          <tr
            key={rowIndex}
            className="table-row"
            style={{ cursor: to ? 'pointer' : 'default' }}
            onClick={to ? () => handleRowClick({ data: row.data, url: row.url }) : () => toggleRow(rowIndex, row)}>
            {filteredColumns.map((column, colIndex) => {
              return (
                <td
                  key={colIndex}
                  className={column.classNameTD}
                  style={
                    tooltip
                      ? {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '200px',
                        padding: '2px 0px 2px 0px',
                      }
                      : {}
                  }
                  title={
                    tooltip && !column.isCustom && String(row[column.dataField] ?? '').length > 25
                      ? row[column.dataField]
                      : undefined
                  }>
                  {column.isCustom ? (
                    column.customFormatter(
                      column.dataField.reduce((acc, field) => {
                        acc[field] = row[field];
                        return { ...acc, rowIndex, popUp, setPopUp, setPopUpData, func };
                      }, {}),
                    )
                  ) : (
                    <div
                      className={`${typeof row[column.dataField] === 'number' ? 'td-num' : 'td-text'}`}
                      style={
                        column.showFull
                          ? {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            padding: '2px 0px 2px 0px',
                          }
                          : tooltip
                            ? {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '200px',
                              padding: '2px 0px 2px 0px',
                            }
                            : {}
                      }
                      title={
                        tooltip &&
                          !column.showFull &&
                          String(row[column.dataField] ?? '').length > 25
                          ? row[column.dataField]
                          : undefined
                      }
                    >
                      {tooltip && !column.showFull && String(row[column.dataField] ?? '').length > 50
                        ? `${String(row[column.dataField]).slice(0, 50)}...`
                        : row[column.dataField]}
                    </div>
                  )}
                </td>
              );
            })}
          </tr>
          {expandedRowIndices.includes(rowIndex) && showCollapseTable && (
            <tr className="table-row-collapse">
              <td colSpan={filteredColumns.length}>
                <div style={{ padding: '10px', background: '#f5f5f5' }}>
                  <strong>Raw Material Info:</strong>
                  <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#4b5564' }}>
                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>Product Name</th>
                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>Available Qty</th>
                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>Lot No</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(collapseTableData[row.move_id] || []).map((item) => (
                        <tr key={item.id}>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {item.display_name}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {item?.selected_lot?.[0]?.available_qty ?? 'N/A'}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {item?.selected_lot?.[0]?.name ?? 'N/A'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          )}
        </>
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  colFilter: PropTypes.bool,
  to: PropTypes.string,
};
